// native
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

// service
import { AuthService } from './core/services/auth.service';
import { GlobalsService } from './core/services/globals.service';
import { StylesService } from './core/services/styles.service';
import { ItemsDisplayService } from './core/services/items-display.service';
import { ToastService } from './core/services/toast.service';
import { UserService } from './core/services/user.service';
import { VersionService } from './core/services/version.service';
import { LegacyService } from './core/services/legacy.service';
import { CitationsQueueService } from './core/services/citations-queue.service';
import { LocaleService } from './core/services/locale.service';
import { MatcherService } from './core/services/matcher.service';

// model
import { IAppConfig, IUser } from './models';

@Component({
  selector: 'scs-container',
  templateUrl: `./container.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContainerComponent implements OnInit {

  @Input() appConfig: IAppConfig;

  isUserSubsciptionActive: boolean = true;

  isUserLoading = true;

  constructor(
    public authService: AuthService,
    public globalsService: GlobalsService,
    public itemsDisplayService: ItemsDisplayService,
    public citationsQueueService: CitationsQueueService,
    private stylesService: StylesService,
    private toastService: ToastService,
    private userService: UserService,
    private versionService: VersionService,
    public legacyService: LegacyService,
    private localeService: LocaleService,
    private matcherService: MatcherService
  ) { }

  ngOnInit(): void {
    this.globalsService.setAppConfig(this.appConfig);

    window.addEventListener('offline', () => this.toastService.showNoInternet());

    this.versionService.getVersionFile();
    this.versionService.setCheckNewVersionListener();

    if (!this.authService.isLoggedIn()) {
      return;
    }

    this.userService.getUserInfo();

    this.userService.user$.subscribe((user: IUser) => {
      if (!user) {
        return;
      }

      this.userService.registerUser();

      this.matcherService.setMatcherCollection(user.organization?.id);

      this.globalsService.initialLoading$.next(false);

      this.isUserSubsciptionActive = !!user.licence?.active;

      if (!this.isUserSubsciptionActive) {
        return;
      }

      this.globalsService.appConfig.getBiblioMeta().then(meta => {
        this.stylesService.calculateStyles(meta?.styleTitle);
        this.localeService.setLanguageAndLocale(meta?.options ? meta.options.language : null);
        this.globalsService.isSectionsModeOn = !!meta?.options?.isSectionsModeOn;
      })
        .catch(err => { });
    }, err => { });
  }
}
